import React from 'react';
import CommerceDocsAdminPage from './CommerceDocsAdminPage';

export default function AdminReceiptsPage() {
  return <CommerceDocsAdminPage mode="receipt" />;
}
